<template>
     <import-notice-common-new isNew></import-notice-common-new>
</template>
<script>
import importNoticeCommonNew from './importNoticeCommonNew.vue';

export default {
    name: 'importNoticeAdd',
    components: {
        importNoticeCommonNew,
    },
};
</script>
